// ----------------------------------------------------------------------
export const IconButton = ({ theme }) => {
    return {
        MuiIconButton: {
            styleOverrides: {
                root: {
                    '&:hover': {
                        backgroundColor: theme.palette.grey[5008]
                    }
                }
            }
        }
    };
};
//# sourceMappingURL=IconButton.js.map